<template>
  <client-only>
    <div class="__main-wrapper" :class="isMobile ? 'mobile' : ''">
      <header class="account-header">
        <div class="account-header__logo">
          <a :href="localePath(`/`)">
            <img src="@/assets/img/header/logo.svg" alt="logo" />
          </a>
        </div>
        <HelpSelectLanguage />
      </header>
      <!-- <header class="account-header" v-else>
            <div class="account-header__logo">
                <img src="@/assets/img/header/logo.svg" alt="logo">
            </div>
        </header> -->
      <Nuxt />
      <setupPassword
        :is-active="
          $cookies.get('setupAccount') && $cookies.get('setupAccount').length < 0 && !userInfo.is_password_entered
        "
        :header-translate="headerTranslate"
        @close="userInfo.is_password_entered = !userInfo.is_password_entered"
      />
      <PortalTarget name="popups" multiple></PortalTarget>
      <notification-view />
    </div>
  </client-only>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    components: {
      setupPassword: () => import('@/components/pop-up/setupPassword.vue'),
      NotificationView: () => import('@/components/common/VNotificationsView'),
      HelpSelectLanguage: () => import('@/components/HelpSelectLanguage.vue'),
    },
    asyncData({ $cookies, store }) {
      const userInfo = store.state.userInfo

      return {
        userInfo,
        $cookies,
      }
    },

    data: () => ({
      isMobile: false, // Initialize for SSR
    }),
    mounted() {
      // Only initialize on client-side
      const { matches } = window.matchMedia('(max-width: 576px)')
      this.isMobile = matches
    },
    head() {
      return this.$nuxtI18nHead()
    },
    computed: {
      availableLocales() {
        return this.$i18n.locales.filter((i) => i.code !== this.$i18n.locale)
      },
      ...mapState(['userInfo', 'headerTranslate']),
    },
  }
</script>

<style lang="scss">
  .account-header {
    z-index: 500;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    padding: 12px 0;
    padding-bottom: 7px;
    background: #fff;
    border-bottom: 1px solid hsl(0, 0%, 85%);
    display: flex;
    gap: 19px;

    &__logo {
      margin-left: 20px;
      cursor: pointer;
      width: 80px;
      height: 25px;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }
</style>
